<template>
    <div>

        <div class="container-fluid">
            <div class="row">

                <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                    <div class="container-fluid">
                        <div class="row">




                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">



                                <h3>Sevilla</h3>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <div
                                                class="btn-group-vertical buttons"
                                                role="group"
                                                aria-label="Basic example"
                                        >
                                            <input type="text" v-model="nuevoNombre" class="form-control">
                                            <button class="btn btn-secondary" @click="add">Añadir</button>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                    <draggable
                                            :list="empleados"
                                            :disabled="!enabled"
                                            class="list-group"
                                            ghost-class="ghost"
                                            @start="dragging = true"
                                            @end="guardarOrden(0)"
                                    >
                                        <div
                                                class="list-group-item"
                                                v-for="element in empleados"
                                                :key="element.nombre"
                                        >
                                            {{ element.nombre }}
                                        </div>
                                    </draggable>
                                </div>

                            </div>



                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">



                                <h3>Córdoba</h3>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <div
                                                class="btn-group-vertical buttons"
                                                role="group"
                                                aria-label="Basic example"
                                        >
                                            <input type="text" v-model="nuevoNombreCordoba" class="form-control">
                                            <button class="btn btn-secondary" @click="addCordoba">Añadir</button>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                    <draggable
                                            :list="empleadosCordoba"
                                            :disabled="!enabledCordoba"
                                            class="list-group"
                                            ghost-class="ghost"
                                            @start="draggingCordoba = true"
                                            @end="guardarOrden(1)"
                                    >
                                        <div
                                                class="list-group-item"
                                                v-for="elementCordoba in empleadosCordoba"
                                                :key="elementCordoba.nombre"
                                        >
                                            {{ elementCordoba.nombre }}
                                        </div>
                                    </draggable>
                                </div>


                                <!--<draggable v-model="empleados" group="people" @start="drag=true" @end="drag=false">
                                    <div v-for="element in empleados" :key="element.id">{{element.nombre}}</div>
                                </draggable>-->

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>

</template>

<script>

//import MonthPicker from 'vue-month-picker'
import axios from 'axios'
import draggable from 'vuedraggable'

//axios.defaults.baseURL = 'http://localhost/FreeTourControl/api'
axios.defaults.baseURL = 'https://app.freetoursevilla.es/api'

export default {
    components: {
      draggable
    },
  data () {
    return {

      enabled: true,
      empleados:[],
      dragging: false,
      enabledCordoba: true,
      empleadosCordoba:[],
      draggingCordoba: false,
      nuevoNombre:"",
      nuevoNombreCordoba:""
      }
  },
    created() {



        this.getEmpleadosWeb0();
        this.getEmpleadosWeb1();

    },
    mounted () {


    },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  methods: {

    add() {
      if(this.nuevoNombre!="") {
        this.empleados.push({nombre: this.nuevoNombre, orden: 0,});
        guardarOrden(0);
        this.nuevoNombre="";
      }
    },
    addCordoba() {
      if(this.nuevoNombreCordoba!="") {
        this.empleadosCordoba.push({nombre: this.nuevoNombreCordoba, id: 0});
        guardarOrden(1);
        this.nuevoNombreCordoba = "";
      }

    },

    guardarOrden(web){
      this.dragging = false;
      //hacer axios, mandar el array de empleados, en el api borarr empleados y guardarlos en el orden que llegan.


      let formData = new FormData();

      formData.append('web', web);
      if(web==0){
        formData.append('empleados', JSON.stringify(this.empleados));
      }else{
        formData.append('empleados', JSON.stringify(this.empleadosCordoba));
      }

      axios.post('/set.orden.empleados.php', formData)
        .then(response => {



        })
        .catch(error => {
          console.log(error);
        })

    },



      getEmpleadosWeb0(){
        let formData = new FormData();

        formData.append('web', 0);

        axios.post('/get.empleados.orden.php', formData)
          .then(response => {

            this.empleados = response.data;

          })
          .catch(error => {
            console.log(error);
          })
      },
      getEmpleadosWeb1(){
        let formData = new FormData();

        formData.append('web', 1);

        axios.post('/get.empleados.orden.php', formData)
          .then(response => {

            this.empleadosCordoba = response.data;

          })
          .catch(error => {
            console.log(error);
          })
      }
  }
}
</script>
<style>
    .buttons {
        margin-top: 35px;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
</style>